module.exports = __webpack_public_path__ + "img/heart-active.0755e6f5.png";